import React, { createContext, ReactNode, useState } from 'react';
import { UserRole } from 'state/user/UserTypes';
const viewMode = 'VIEW_MODE';

type ViewModeContext = { viewingAs: UserRole; setViewingMode: (role: UserRole) => void };
const initialViewModeState: ViewModeContext = {
   viewingAs: (window.sessionStorage.getItem(viewMode) as UserRole) || 'admin',
   setViewingMode: () => {},
};

export const AdminViewModeContext = createContext<ViewModeContext>(initialViewModeState);

export default function AdminViewModeProvider({ children }: { children: ReactNode }): JSX.Element {
   const [mode, setMode] = useState<ViewModeContext>(initialViewModeState);

   const setViewingMode = (role: UserRole) => {
      setMode(prev => ({ ...prev, viewingAs: role }));
      window.sessionStorage.setItem(viewMode, role);
   };

   return <AdminViewModeContext.Provider value={{ setViewingMode, viewingAs: mode.viewingAs }}>{children}</AdminViewModeContext.Provider>;
}
